<template>
  <div class="mt-3">
    <div class="container mt-30">
      <div class="row">
        <div class="col-md-3">
          <div class="input-group flex-nowrap subtitle_desktop">
          <span class="input-group-text input-search" id="addon-wrapping">
            <i class="fas fa-search"></i>
          </span>
            <input type="text"
                   class="form-control input-search"
                   v-model="filters.name_cont"
                   @keyup.enter="search"
                   :placeholder="$t('events.search')"/>
          </div>
          <div class="input-group flex-nowra ">
            <input type="text"
                   class="form-control input-search input_mobile_event"
                   aria-label="event"
                   aria-describedby="addon-wrapping"
                   v-model="filters.name_cont"
                   @keyup.enter="search"
                   :placeholder="$t('events.search')">
            <span class="input-group-text input-search input_mobile_event">
            <img src="../../images/mobile/filtros.png" @click="filterState = true"/>
          </span>
            <span id="addon-wrapping"
                  @click="search"
                  class="input-group-text input-search input_mobile_event button_search_mobile">
            <i class="fas fa-search"></i>
          </span>
          </div>
          <div class="row filter_mobile mt-30" v-if="filterState">
            <div class="col-6">
              <h6>{{ $t("events.filter") }}</h6>
            </div>
            <div class="col-6">
              <div align="right">
                <p @click="filterState = false" class="close-filters">
                  <span>x</span>
                </p>
              </div>
            </div>
            <hr class="separate"/>
            <div class="col-6 mt-30">
              <select v-model="filters.month_eq" @change="search" class="form-select input-search">
                <option value="">{{ $t("events.month") }}</option>
                <option v-for="(month, idx) in months" :key="idx" :value="month.value">
                  {{ month.text }}
                </option>
              </select>
            </div>
            <div class="col-6 mt-30">
              <select v-model="filters.year_eq" @change="search" class="form-select input-search">
                <option value="">{{ $t("events.year") }}</option>
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
            <div class="col-12 mt-30">
              <button class="button_filter" @click="search">
                {{ $t("events.search") }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-3 subtitle_desktop">
          <select v-model="filters.month_eq"
                  @change="search"
                  class="form-select input-search">
            <option value="">{{ $t("events.month") }}</option>
            <option v-for="(month, idx) in months" :key="idx" :value="month.value">
              {{ month.text }}
            </option>
          </select>
        </div>
        <div class="col-md-3 subtitle_desktop">
          <select v-model="filters.year_eq" class="form-select input-search">
            <option value="">{{ $t("events.year") }}</option>
            <option v-for="(year, index) in years" :key="index" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div class="col-md-2 subtitle_desktop">
          <button class="button-search" @click="search">
            {{ $t("events.search") }}
          </button>
        </div>
      </div>
      <div class="mt-5">
        <div v-if="hasEvents" class="row">
          <div class="col-md-4 col-lg-3" v-for="event in events" :key="event.id">
            <div class="event-card card">
              <a :href="event.external_url" v-if="event.external">
                <img :src="event.logo_url" class="card-img-top" alt="event.name" />
              </a>
              <router-link :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}" v-if="!event.external">
                <img :src="event.logo_url" class="card-img-top" alt="event.name" />
              </router-link>
              <div class="card-body">
                <div class="row" v-if="event.external">
                  <div class="col-lg-7 col-7">
                    <a :href="event.external_url">
                      <p class="name">{{ event.name }}</p>
                    </a>
                    <p class="date">{{ event.event_at | toLongDate }}</p>
                  </div>
                </div>

                <div class="row" v-if="!event.external">
                  <div class="col-lg-7 col-7">
                    <router-link :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}">
                      <p class="name">{{ event.name }}</p>
                    </router-link>
                    <p class="date">{{ event.event_at | toLongDate }}</p>
                  </div>
                  <div class="col-lg-5 col-5">
                    <div align="right" v-if="event.sale">
                      <div class="cart" @click="addToCart(event.identifier)">
                        <i class="fas fa-shopping-cart"></i>
                      </div>
                      <div v-if="event.active_pre_order">
                        <p class="price" v-if="event.price_album === 0"></p>
                        <p class="price" v-else>{{event.pre_order_item.discount_price | toCurrency}}</p>
                      </div>
                      <div v-else>
                        <p class="price" v-if="event.price_album === 0"></p>
                        <p class="price" v-else>{{ event.price_album | toCurrency }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-md-12" v-show="!loading">
            <div class="alert alert-primary" role="alert">
              {{ $t("events.notFound") }}
            </div>
          </div>
        </div>
        <div class="row mb-50" v-show="!loading && more">
          <div class="col-lg-12">
            <div align="center">
              <button @click="nextPage" class="button-plus">
                {{ $t("events.loadMore") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader :visible="loading"></Loader>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loader from '../../components/Loader';

export default {
  name: "Events",
  data() {
    return {
      page: '1',
      overlay: false,
      events: [],
      filters: {
        name_cont: '',
        year_eq: '',
        month_eq: '',
      },
      loading: true,
      filterState: false,
      years: ['2019', '2020', '2021', '2022', '2023', '2024'],
      months: [
        {value: '01', text: 'Enero'},
        {value: '02', text: 'Febrero'},
        {value: '03', text: 'Marzo'},
        {value: '04', text: 'Abril'},
        {value: '05', text: 'Mayo'},
        {value: '06', text: 'Junio'},
        {value: '07', text: 'Julio'},
        {value: '08', text: 'Agosto'},
        {value: '09', text: 'Septiembre'},
        {value: '10', text: 'Octubre'},
        {value: '11', text: 'Noviembre'},
        {value: '12', text: 'Diciembre'},
      ]
    }
  },
  components: {
    Loader
  },
  async created() {
    this.page = (this.$route.query.page) ? this.$route.query.page : this.page
    this.setFilter("month_eq")
    this.setFilter("year_eq")
    this.setFilter("name_cont")
    await this.getEvents()
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),
        
    async fetch() {
      try {
        const response = await this.$http.get(`/api/v2/events/`, {
          params: this.queryParams
        })

        if (response.status == 200 || response.status == 304) {
          return response.data.events
        } else {
          return []
        }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async getEvents() {
      this.loading = true
      const events = await this.fetch()
      this.events.push.apply(this.events, events)
      this.loading = false
    },
    async search() {
      this.page = 1
      this.events = []
      this.$router.push({query: this.queryParams})
    },
    async nextPage() {
      this.page = parseInt(this.page) + 1
      await this.getEvents()
    },
    async addToCart(eventId) {
      const params = {event_id: eventId, photo_id: null}
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params)
    },
    setFilter(name) {
      let param = this.$route.query[`q[${name}]`]
      this.filters[name] = (param) ? param : ""
    }
  },
  computed: {
    hasEvents() {
      return this.events.length > 0
    },
    queryParams() {
      return {
        "page": this.page,
        "q[month_eq]": this.filters.month_eq,
        "q[name_cont]": this.filters.name_cont,
        "q[year_eq]": this.filters.year_eq
      }
    },
    more() {
      return this.events.length > 0
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/variables';

.close-filters {
  font-size: 25px;
  color: #003B4D;
  margin-top: -10px;

  span {
    cursor: pointer;
  }
}

.event-card {
  cursor: pointer;

  a {
    text-decoration: none;
  }

  .name {
    font-style: normal;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    margin-bottom: 0.5rem;
  }

  .date {
    font-style: normal;
    font-weight: 300;
    font-size: 17px;
  }

  .cart {
    background: $primary-base;
    padding: 7px;
    font-size: 24px;
    width: 50px;
    text-align: center;
    text-decoration: none;
    border-radius: 60px;
    cursor: pointer;

    i {
      color: #FFF;
    }
  }

  .price {
    font-style: normal;
    font-weight: bolder;
    font-size: 18px;
    line-height: 40px;
    color: #333333;
  }
}

.app-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background: rgb(0, 0, 0, 0.3);
}
</style>
